module.exports = __webpack_public_path__ + "static/media/white-value-to-customer.142cf15f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-value-to-customer.svg
// module id = 314
// module chunks = 0